import StudentDebtTable from './StudentDebtTable';
export default StudentDebtTable;
